export default __webpack_public_path__ + "static/media/login-cat-image.ecbe13dc.png";